import Chip from '../shared/Chip';

// Priority tiers map to the underlying scale (MES-2526): High = 2, Medium = 3, Low = 4.
// Only High and Low surface a pill on the clients grid; Medium (the default) and any
// legacy/out-of-range value render nothing (MES-2528 AC4).
const PRIORITY_HIGH = 2;
const PRIORITY_LOW = 4;

// Chip builds Tailwind classes as bg-{color}-100 / text-{color}-700, so the color must be a
// standard palette whose class literals already survive purge (no safelist exists in this project).
// 'emerald' (green, High) and 'sky' (blue, Low) both appear elsewhere in source and render safely.
const HIGH_CHIP_COLOR = 'emerald';
const LOW_CHIP_COLOR = 'sky';

interface IClientPriorityIndicatorProps {
  priorityLevel?: number;
}

// Presentational only — callers are responsible for role-gating (GR_ADMIN). Renders the shared
// pill with "High" (emerald) or "Low" (sky), or nothing for Medium/undefined/legacy.
export const ClientPriorityIndicator = ({ priorityLevel }: IClientPriorityIndicatorProps): JSX.Element | null => {
  if (priorityLevel === PRIORITY_HIGH) {
    return (
      <span className="ml-2 inline-flex whitespace-nowrap">
        <Chip color={HIGH_CHIP_COLOR}>High</Chip>
      </span>
    );
  }

  if (priorityLevel === PRIORITY_LOW) {
    return (
      <span className="ml-2 inline-flex whitespace-nowrap">
        <Chip color={LOW_CHIP_COLOR}>Low</Chip>
      </span>
    );
  }

  return null;
};
